import React from 'react';
import { PositionerAbsolute, PositionerFixed, PositionerRelative, } from '../styled/Modal';
const Positioner = function Positioner({ scrollBehavior, ...props }) {
    // default 'inside'
    let PositionComponent = PositionerAbsolute;
    if (scrollBehavior === 'outside') {
        PositionComponent = PositionerRelative;
    }
    else if (scrollBehavior === 'inside-wide') {
        PositionComponent = PositionerFixed;
    }
    return React.createElement(PositionComponent, Object.assign({}, props));
};
export default Positioner;
//# sourceMappingURL=Positioner.js.map